import ConsoleApi from "@/consoleapi/consoleApi";

import {AxiosResponse} from "axios";

/**
 *
 */
export default class CallVerification extends ConsoleApi {
    protected readonly resource = '/2fa';

    /**
     * @param accountId
     * @param service
     * @param from
     * @param to
     * @param body
     * @param channel
     * @param language
     */
    public send(accountId: string, service: string, from: string,
                to: string, body: string, channel: string, language: string, accountSid: string): Promise<AxiosResponse> {
        return this.axios.post(this.requestUri + this.getAccountResource(accountId) + '/send', {
            "service": service,
            "from": from,
            "to": to,
            "body": body,
            "channel": channel,
            "language": language,
            "accountSid": accountSid,
        },{
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }

    /**
     * @param accountId
     * @param service
     * @param requestId
     * @param code
     * @param to
     * @param accountSid
     * */
    public verify(accountId: string, service: string, requestId: string,
                  code: string, to: string, accountSid: string): Promise<AxiosResponse> {
        return this.axios.post(this.requestUri + this.getAccountResource(accountId) + '/verify', {
            "service": service,
            "requestId": requestId,
            "code": code,
            "to": to
        },{
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }
}